import { cn } from '#lib/helpers/class.js';
import { Icon } from '@iconify-icon/react';

export function ImageDiff(props) {
    const { incomingMedia, updatedMedia, onUpdateData, onRestoreData, type = 'cover' } = props;

    const isUpdated = updatedMedia.src === incomingMedia.src;

    if (!incomingMedia?.src) return null;

    return (
        <div>
            <p className="pt-4 pb-2 w-full font-semibold text-left">{_t.edit.fields[type]()}</p>

            <figure
                className={cn(
                    'relative rounded overflow-hidden col-span-1 aspect-video border border-neutral-500',
                    isUpdated && 'border-4 border-primary-500'
                )}
            >
                <img src={incomingMedia.src} alt={type} className="object-cover w-full h-full" />
                <div
                    className={cn(
                        'absolute left-0 top-0 w-full h-full flex justify-center items-center bg-white bg-opacity-75 opacity-0 transition-all hover:opacity-100 cursor-pointer',
                        isUpdated ? 'text-red-500 hover:text-red-500' : 'text-primary-500 hover:text-primary-500'
                    )}
                    onClick={() => {
                        isUpdated ? onRestoreData() : onUpdateData();
                    }}
                >
                    <Icon
                        icon={isUpdated ? 'fa6-solid:xmark' : 'el:ok'}
                        width="1.8rem"
                        height="1.8rem"
                        className="px-2"
                    />
                </div>
            </figure>
        </div>
    );
}
